import { DefaultTheme, Title } from "@deliverr/ui";
import { LoadingSpinner } from "@deliverr/ui-facility";
import styled from "@emotion/styled";
import React, { useState } from "react";
import { ManifestTable } from "./components";
import { useManifests } from "./useManifests";
import { ManifestCarrier } from "sortation/utils/ManifestCarrier";
import { EpostManifestTable } from "./components/EpostManifestTable";
import CarrierSelect from "../../components/CarrierSelect";

const Container = styled.div<{}, DefaultTheme>(({ theme }) => `margin: ${theme.spacing.S5};`);

const Card = styled.div<{}, DefaultTheme>(
  ({ theme }) => `
  padding: ${theme.spacing.S5};
  background: ${theme.colors.NEUTRAL["00"]};
  border-radius: ${theme.border.radius.R5};
  box-shadow: ${theme.shadow.S2};
  margin-bottom: ${theme.spacing.S5};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.S4};
`
);

const StyledContainer = styled(Container)`
  margin-bottom: 30px;
`;

export const Manifests = () => {
  const [carrier, setCarrier] = useState<ManifestCarrier>(ManifestCarrier.DHL);
  const {
    manifests,
    epostManifests,
    manifestsCurrentlyDownloading,
    isLoading,
    downloadManifest,
    sortationId,
  } = useManifests(carrier);

  return (
    <StyledContainer>
      <Card>
        <CarrierSelect carrier={carrier} setCarrier={(newCarrier: ManifestCarrier) => setCarrier(newCarrier)} />
        <LoadingSpinner loading={isLoading} text="Loading Manifests">
          <Title> Manifests for {sortationId} </Title>
          {carrier === ManifestCarrier.DHL ? (
            <ManifestTable
              manifests={manifests}
              downloadManifest={downloadManifest}
              manifestsCurrentlyDownloading={manifestsCurrentlyDownloading}
            />
          ) : (
            <EpostManifestTable manifests={epostManifests} downloadManifest={downloadManifest} />
          )}
        </LoadingSpinner>
      </Card>
    </StyledContainer>
  );
};
